export default __webpack_public_path__ + "static/media/bindrr-screenshot.e5f2801a.jpg";